// "events/abc/stages" → "events/stages", "users/u1/private/blocks" →
// "users/private": collection names only, never document ids.
export function collectionOf(path: string): string {
  return path
    .split('/')
    .filter((_, i) => i % 2 === 0)
    .join('/')
}

// Literal route segments that follow a first segment; anything else in that
// position is a record id. Kept in step with the routes in App.tsx.
const STATIC_SEGMENTS = new Set(['all', 'review', 'metrics', 'schedule', 'totems', 'blocked', 'map', 'friends', 'totem'])

// "/events/shambhala-2026/schedule" → "/events/:id/schedule". Admin pages keep
// their second segment because it names the page, not a record.
export function routeOf(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)
  const isAdmin = segments[0] === 'admin'
  return '/' + segments
    .map((s, i) => (i === 0 || (isAdmin && i === 1) || STATIC_SEGMENTS.has(s) ? s : ':id'))
    .join('/')
}
